var handleApiErrors = function (response) {
    // Response status is not 200
    if ((response === null || response === void 0 ? void 0 : response.status) !== 200 && (response === null || response === void 0 ? void 0 : response.data)) {
        var json = response.data;
        if (response.status === 401) {
            throw new Error(json.result.message);
        }
        else if (response.status === 500) {
            throw new Error(json.result.message);
        }
        else if (response.status === 404) {
            throw new Error(json.result.message || 'Not Found');
        }
        else if (response.status === 400) {
            throw new Error(json.result.message);
        }
    }
    // Response status - 200
    return response === null || response === void 0 ? void 0 : response.data;
};
export { handleApiErrors };
